import { AfterViewInit, Component, ComponentRef, ElementRef, OnInit, signal, ViewChild, ViewContainerRef } from '@angular/core';

import * as xlsx from 'xlsx';
import { Utils } from 'src/app/utils/utils';
import { GeoUtils } from 'src/app/utils/geo-utils';
import { DateUtils } from 'src/app/utils/date-utils';
import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { MapBounds, MapComponent, MapLatLng, MapMarker } from 'movisat-maps';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { SsoService } from 'src/app/services/sso/sso.service';
import { ElementsService } from 'src/app/services/elements/elements.service';
import { CerraduraService } from 'src/app/services/cerraduras/cerradura.service';

import { ElementoModel } from 'src/app/services/elements/models/elem.model';
import { CerraduraModel } from 'src/app/services/cerraduras/models/cerradura.model';
import { PosicionCerraduraModel } from 'src/app/services/cerraduras/models/posicionCerradura.model';
import { ElementoCerraduraModel } from 'src/app/services/cerraduras/models/elementoCerradura.model';

import { MainComponent } from 'src/app/components/main/main.component';
import { HeaderComponent } from 'src/app/components/header/header.component';

import { ConfiguracionCerradurasEditComponent } from 'src/app/components/configuracion-cerraduras/configuracion-cerraduras-edit/configuracion-cerraduras-edit.component';
import { ToastrService } from 'ngx-toastr';
import { MenuComponent } from 'src/app/components/main/menu/menu.component';
import { jqxDateTimeInputComponent } from 'jqwidgets-ng/jqxdatetimeinput';
import { WindowComponent } from 'movisat-common-gui';
import { CerradurasTransformerService } from 'src/app/services/cerraduras/transformers/cerraduras-transformer.service';


@Component({
  selector: 'app-listado-cerradura',
  templateUrl: './listado-cerradura.component.html',
  styleUrls: ['./listado-cerradura.component.css']
})
export class ListadoCerraduraComponent implements OnInit, AfterViewInit {
  @ViewChild('listCerraduras') public listCerraduras: WindowComponent;

  @ViewChild('header') public header: HeaderComponent;
  @ViewChild('gridCerraduras') public gridCerraduras: jqxGridComponent;

  @ViewChild('informacionCerradura', { read: ViewContainerRef }) public informacionCerradura;
  @ViewChild('formLockConfiguracion', { read: ViewContainerRef }) public editConfiguracionComponent;

  protected actions = [
    {type: "button", action:"centrar", value: "", label: this.translate('Centrar'), icon: '/assets/images/localizar.png' },
    /* TODO: ajustar tamaño de este boton */
    {type: "button", action:"pedir_posicion", value: "", label: this.translate('Pedir_localizacion'), icon: '/assets/images/localizar.png' },
    {type: "button", action:"salir", value: "", label: this.translate('Salir') }
  ];

  protected actionButtonClicked(event: { action: string }): void {
    if(event.action === 'centrar') {
      this.onPosicionar();
      return;
    }

    if(event.action === 'pedir_posicion') {
      this.onLocalizar()
      return;
    }

    if(event.action === 'salir') {
      this.closeWindow();
      return;
    }
  }

  private componentRef = null;
  public static instance: ListadoCerraduraComponent = null; // Para controlar que sólo se cree una instancia
  protected theme = environment.tema;
  private subscriptionOnMarkerDragEnd;

  //  Esto es para que los textos en los controles del grid salgan en español
  protected langGrid = JqWidgets.getLocalization('es');
  private dataSource;
  protected dataAdapter: object;
  private cerraduras = signal<CerraduraModel[]>([]);
  public cerradura: CerraduraModel = new CerraduraModel();
  private elemento: ElementoCerraduraModel = new ElementoCerraduraModel();
  private map: MapComponent;
  private elementos: ElementoModel[] = [];
  private checkSelect: CerraduraModel[] = [];
  private empresaId: number = this.ssoService.getTicket().Empresa.IdGestion;
  protected viewForm: boolean = false;
  private clickTimer;
  private formLockConfiguracion;
  private verDesdeColumn: boolean = false;
  private markers: MapMarker[] = [];
  private metrosFilter: number = 0;
  protected detalleCerradura;

  public windowTitle = signal<string>(this.translate('Cerradura_iot') + '(0)');

  protected loading = signal(false);

  public constructor(
    private cerraduraService: CerraduraService,
    private elementService: ElementsService,
    private ssoService: SsoService,
    private modal: NzModalService,
    private toastrService: ToastrService,
    private cerraduraTransformer: CerradurasTransformerService
  ) {
    ListadoCerraduraComponent.instance = this;
  }

  private createTooltip = (content: string) => {
    return (columnHeaderElement): void => {
      const jqElement = columnHeaderElement[0].parentElement;
      const options = {
        content: content,
        theme: environment.tema,
        width: 'auto',
        height: 'auto',
        position: 'mouse',
        autoHide: true,
      };
      jqwidgets.createInstance(jqElement, 'jqxTooltip', options);
    };
  };

  public columnmenuopening(menu, datafield): boolean | void {
    if (!menu || menu.length === 0  || !datafield) {
      return;
    }

    const dateTimeConfig: { [key: string]: { showTimeButton: boolean; showCalendarButton: boolean; formatString: string } } = {
        'fechaModificacion': { showTimeButton: false, showCalendarButton: true, formatString: 'dd/MM/yyyy' },
        'fechaPeticionPosicion': { showTimeButton: false, showCalendarButton: true, formatString: 'dd/MM/yyyy' },
        'fechaRecepcionPosicion': { showTimeButton: false, showCalendarButton: true, formatString: 'dd/MM/yyyy' },
        'horaModificacion': { showTimeButton: true, showCalendarButton: false, formatString: 'HH:mm:ss' },
        'horaRecepcionPosicion': { showTimeButton: true, showCalendarButton: false, formatString: 'HH:mm:ss' },
        'horaPeticionPosicion': { showTimeButton: true, showCalendarButton: false, formatString: 'HH:mm:ss' }
    };

    if (!dateTimeConfig[datafield]) {
        return;
    }

    const configureDateTimeInput = (menuElement: HTMLElement, options: { showTimeButton: boolean; showCalendarButton: boolean, formatString: string }) => {
        if (!menuElement) return;

        const dateTimeInputs = menuElement.querySelectorAll('.jqx-datetimeinput');
        dateTimeInputs.forEach((input: HTMLElement) => {
            const elementRef = new ElementRef(input);
            const jqxDateTimeInput = new jqxDateTimeInputComponent(elementRef);
            const inputDate = jqwidgets.createInstance(`#${jqxDateTimeInput.elementRef.nativeElement.id}`, 'jqxDateTimeInput', {
                width: '100%', height: 25
            });
            inputDate.setOptions(options);
        });
    };

    const divElement: HTMLElement = menu[0];
    configureDateTimeInput(divElement, dateTimeConfig[datafield]);
}

  public cellClass = (_row: number, _columnfield: unknown, value: unknown): string => {
    if (value) {
      return 'cellTooltip';
    }
    return '';
  }


  protected rendexTextGeneric(_row: number, columnfield: string, value: string,
    _defaulthtml: string, _columnproperties: unknown, rowdata: {pedirPosicion: number}): string {
    if (columnfield == 'fechaModificacion' || columnfield == 'horaModificacion') {
      switch (rowdata.pedirPosicion) {
        case 1: {
          return `
            <div style="margin-left: 4px; margin-top: 5px; text-align: left;">
              <span onmouseover="this.style.backgroundColor='gray'; this.style.color='white';"
              onmouseout="this.style.backgroundColor=''; this.style.color='';">
                ${AppComponent.translate('Pendiente')}
              </span>
            </div>
          `;
        }
      }
    }
  }

  public columnGroupsCerraduras = [
    { text: this.translate('Identificacion'), align: 'center', name: 'direccionIdentificacionGroup', },
    { text: this.translate('Elemento'), align: 'center', name: 'direccionElementoGroup', }
  ];
  public columns = [];

  /**Inicializa el componente
   */
  public init(componentRef: ComponentRef<ListadoCerraduraComponent>): void {
    this.componentRef = componentRef;
  }

  public ngOnInit(): void {
    this.map = MainComponent.getInstance().getMap();
  }

  public ngAfterViewInit(): void {
    this.initGrid();
    this.onSubscribeMap();
    this.getCerraduras();
  }

  private closeWindow(): void {
    this.listCerraduras.closeWindow();
  }

  protected closeDetailCerradura(): void {
    this.detalleCerradura = false;
  }

  private initGrid(): void {
    this.gridCerraduras.columngroups(this.columnGroupsCerraduras);
    this.columns = [
      { datafield: 'selec', hidden: true },
      {
        width: 112,
        text: this.translate('Acciones'),
        columntype: 'text',
        editable: false,
        datafield: 'Botones',
        groupable: false,
        menu: false,
        sortable: false,
        clickable: false,
        filterable: false,
        pinned: false,
        createwidget: (
          row: any,
          column: any,
          value: string,
          htmlElement: HTMLElement
        ): void => {
          this.initBtnColumn(row, column, value, htmlElement);
        },
        initwidget: (
          row: any,
          column: any,
          value: string,
          htmlElement: HTMLElement
        ) => {
          this.initBtnColumn(row, column, value, htmlElement);
        },
      },
      {
        datafield: 'id',
        hidden: true,
      },
      {
        datafield: 'elementoId',
        hidden: true,
      },
      {
        text: AppComponent.translate('Tipo_producto'),
        datafield: 'tipoProducto',
        filtertype: 'checkedlist',
        cellclassname: this.cellClass,
        width: 80,
        rendered: this.createTooltip(AppComponent.translate('Tipo_producto')),
      },
      {
        text: AppComponent.translate('F_ult_conex'),
        datafield: 'fechaModificacion',
        filtertype: 'date',
        columntype: 'datetimeinput',
        cellclassname: this.cellClass,
        width: 100,
        cellsformat: 'dd/MM/yyyy',
        cellsrenderer: this.rendexTextGeneric,
        rendered: this.createTooltip(AppComponent.translate('F_ult_conex')),
      },
      {
        text: AppComponent.translate('H_ult_conex'),
        datafield: 'horaModificacion',
        filtertype: 'date',
        cellclassname: this.cellClass,
        columntype: 'datetimeinput',
        width: 100,
        cellsformat: 'HH:mm:ss',
        cellsrenderer: this.rendexTextGeneric,
        rendered: this.createTooltip(AppComponent.translate('H_ult_conex')),
      },
      {
        text: AppComponent.translate('Ns_movisat'),
        width: 170,
        cellclassname: this.cellClass,
        filtertype: 'textbox',
        datafield: 'nsMovisat',
        rendered: this.createTooltip(AppComponent.translate('Ns_movisat')),
      },
      {
        text: AppComponent.translate('Ns_fabricante'),
        width: 170,
        cellclassname: this.cellClass,
        filtertype: 'textbox',
        datafield: 'nsFabricante',
        rendered: this.createTooltip(AppComponent.translate('Ns_fabricante')),
      },
      {
        text: AppComponent.translate('Version'),
        filtertype: 'textbox',
        width: 100,
        cellclassname: this.cellClass,
        datafield: 'version',
        rendered: this.createTooltip(AppComponent.translate('Version')),
      },
      {
        text: AppComponent.translate('Imei'),
        filtertype: 'textbox',
        cellsalign: 'right',
        width: 170,
        cellclassname: this.cellClass,
        datafield: 'imei',
        rendered: this.createTooltip(AppComponent.translate('Imei')),
      },
      { datafield: 'mcc', hidden: true },
      { datafield: 'mnc', hidden: true },
      { datafield: 'icc', hidden: true },
      // Direccion identificación
      { text: AppComponent.translate('Direccion'), width: 100, filtertype: 'textbox', datafield: 'calleIdentificacion', rendered: this.createTooltip(AppComponent.translate('Direccion')),
        cellclassname: this.cellClass, columngroup: 'direccionIdentificacionGroup'
      },
      { text: AppComponent.translate('Municipio'), width: 100, filtertype: 'textbox', datafield: 'municipioIdentificacion', rendered: this.createTooltip(AppComponent.translate('Municipio')),
        cellclassname: this.cellClass, columngroup: 'direccionIdentificacionGroup'
      },
      { text: AppComponent.translate('Poblacion'), width: 100, filtertype: 'textbox', datafield: 'poblacionIdentificacion', rendered: this.createTooltip(AppComponent.translate('Poblacion')),
        cellclassname: this.cellClass, columngroup: 'direccionIdentificacionGroup'
      },
      { text: AppComponent.translate('Provincia'), width: 100, filtertype: 'textbox', datafield: 'provinciaIdentificacion', rendered: this.createTooltip(AppComponent.translate('Provincia')),
        cellclassname: this.cellClass, columngroup: 'direccionIdentificacionGroup'
      },
      { text: 'Nº', width: 20, filtertype: 'textbox', datafield: 'numeroIdentificacion', rendered: this.createTooltip(AppComponent.translate('Num_calle')), cellsalign: 'right',
        cellclassname: this.cellClass, columngroup: 'direccionIdentificacionGroup'
      },
      { text: AppComponent.translate('F_pet_pos'), datafield: 'fechaPeticionPosicion', filtertype: 'date', columntype: 'datetimeinput', width: 100, cellsformat: 'dd/MM/yyyy',   cellclassname: this.cellClass, rendered: this.createTooltip(AppComponent.translate('Fecha_Peticion_Posicion')) },
      { text: AppComponent.translate('H_pet_pos'), datafield: 'horaPeticionPosicion', filtertype: 'date', columntype: 'datetimeinput', width: 100, cellsformat: 'HH:mm:ss',   cellclassname: this.cellClass, rendered: this.createTooltip(AppComponent.translate('Hora_peticion_posicion')) },
      { text: AppComponent.translate('F_rec_pos'), datafield: 'fechaRecepcionPosicion', filtertype: 'date', columntype: 'datetimeinput', width: 100, cellsformat: 'dd/MM/yyyy',cellclassname: this.cellClass , rendered: this.createTooltip(AppComponent.translate('Fecha_recepcion_posicion')) },
      { text: AppComponent.translate('H_rec_pos'), datafield: 'horaRecepcionPosicion', filtertype: 'date', columntype: 'datetimeinput', width: 100, cellsformat: 'HH:mm:ss',cellclassname: this.cellClass, rendered: this.createTooltip(AppComponent.translate('Hora_recepcion_posicion')) },
      {
        text: this.translate('Metros'),
        columntype: 'numberinput',
        datafield: 'metros',
        filtertype: 'number',
        cellsalign: 'right',
        cellclassname: this.cellClass,
        width: 60,
        rendered: this.createTooltip(this.translate('Metros')),
      },
      // Direccion elemento
      { text: AppComponent.translate('Direccion'), width: 100, filtertype: 'textbox', datafield: 'calle', rendered: this.createTooltip(AppComponent.translate('Direccion')),
        cellclassname: this.cellClass, columngroup: 'direccionElementoGroup'
      },
      { text: AppComponent.translate('Municipio'), width: 100, filtertype: 'textbox', datafield: 'municipio', rendered: this.createTooltip(AppComponent.translate('Municipio')),
        cellclassname: this.cellClass, columngroup: 'direccionElementoGroup'
      },
      { text: AppComponent.translate('Poblacion'), width: 100, filtertype: 'textbox', datafield: 'poblacion', rendered: this.createTooltip(AppComponent.translate('Poblacion')),
        cellclassname: this.cellClass, columngroup: 'direccionElementoGroup'
      },
      { text: AppComponent.translate('Provincia'), width: 100, filtertype: 'textbox', datafield: 'provincia', rendered: this.createTooltip(AppComponent.translate('Provincia')),
        cellclassname: this.cellClass, columngroup: 'direccionElementoGroup'
      },
      { text: 'Nº', width: 20, filtertype: 'textbox', datafield: 'numeroCalle', rendered: this.createTooltip(AppComponent.translate('Num_calle')), cellsalign: 'right',
        cellclassname: this.cellClass, columngroup: 'direccionElementoGroup'
      },
      {
        text: AppComponent.translate('Nombre_elemento'),
        datafield: 'elemento',
        filtertype: 'textbox',
        cellclassname: this.cellClass,
        width: 150,
        rendered: this.createTooltip(AppComponent.translate('Nombre_elemento')),
      },
      {
        text: AppComponent.translate('Marca'),
        filtertype: 'checkedlist',
        datafield: 'marca',
        cellclassname: this.cellClass,
        width: 110,
        rendered: this.createTooltip(AppComponent.translate('Marca')),
      },
      {
        text: AppComponent.translate('Modelo'),
        filtertype: 'checkedlist',
        datafield: 'modelo',
        cellclassname: this.cellClass,
        width: 110,
        rendered: this.createTooltip(AppComponent.translate('Modelo')),
      },
      {
        text: AppComponent.translate('Matricula'),
        filtertype: 'textbox',
        datafield: 'matricula',
        cellclassname: this.cellClass,
        width: 110,
        rendered: this.createTooltip(AppComponent.translate('Matricula')),
      },
      {
        text: AppComponent.translate('Observaciones'),
        datafield: 'observaciones',
        menu: false,
        sortable: false,
        cellclassname: this.cellClass,
        width: 110,
        rendered: this.createTooltip(AppComponent.translate('Observaciones')),
      },
    ]
  }

  // Incializa la columna de iconos
  private async initBtnColumn(
    row,
    _column,
    _value: string,
    htmlElement: HTMLElement
  ): Promise<void> {
    htmlElement.innerHTML = '';
    // Creo un contenedor para los botones
    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.gap = '2px';
    btnContainer.style.padding = '2px';

    let rowdata;
    if (isNaN(row)) {
      rowdata = row.bounddata;
    } else {
      rowdata = this.gridCerraduras.getrowdata(row);
    }

    const btnInfo = document.createElement('div');
    btnInfo.innerHTML =
      '<button id=info style="height: 23px; width: 25px; padding: 0; margin: 0; cursor: pointer !important;">' +
      '<i style="font-size: 18px;" class="fas fa-circle-info"></i></button>';
    btnInfo.id = `buttonInfoMap_jqxButton`;
    btnContainer.appendChild(btnInfo);
    htmlElement.appendChild(btnContainer);
    // lo mismo para el resto de botones
    const newIconInfo = document.getElementById('buttonInfoMap_jqxButton');
    if (newIconInfo) {
      btnInfo.title = this.translate('Ficha_cerradura_iot');
    }

    // Capturo el click de los botones
    btnInfo.addEventListener('click', async () => {
      this.cerradura = this.cerraduras().find((cerradura) => cerradura.id === rowdata.id);
      this.cerradura.imsi = this.concatImsi(this.cerradura.mcc, this.cerradura.mnc, this.cerradura.icc);
      this.detalleCerradura = true;
    });

    // si rowdata tiene coordenadas o el cmapo elemento tiene id, añado un botón para ver en el mapa
    if (rowdata && (rowdata.elementoId || (rowdata.lat && rowdata.lng))) {
      const btnViewMap = document.createElement('div');
      btnViewMap.innerHTML =
        '<button id="viewMap" style=" height: 23px; width: 25px;  padding: 0; margin: 0; cursor: pointer !important;">' +
        '<i style="font-size: 18px;" class="fa-sharp fa-solid fa-location-dot"></i></button>';
      btnViewMap.id = `buttonViewMap_jqxButton`;
      btnContainer.appendChild(btnViewMap);

      const newIconViewMap = document.getElementById('buttonViewMap_jqxButton');
      if (newIconViewMap) {
        btnViewMap.title = this.translate('Posicionar_en_mapa');
      }

      btnViewMap.addEventListener('click', async () => {
        this.cerradura = this.cerraduras().find((cerradura) => cerradura.id === rowdata.id);
        this.verDesdeColumn = true;
        // compruebo que no haya cerradura en el mapa
        if (this.markers.length > 0) {
          this.markers.forEach(marker => {
            this.map.removeMarker(marker);
          });
          this.markers = [];
        }
        this.onCentrar(rowdata);
        this.listCerraduras.collapseWindow();
        // minimizo todas las ventanas abiertas
        MainComponent.getInstance().minimizeWindows();
      });
    }

    // si rowdata tiene configuracion, añado un botón para ver la configuración
    if (rowdata && rowdata.configuracion !== null) {
      const btnConfig = document.createElement('div');
      btnConfig.innerHTML =
        '<button id="config" style="height: 23px; width: 25px;  padding: 0; margin: 0; cursor: pointer !important;">' +
        '<i style="font-size: 18px;" class="fa-solid fa-cog"></i></button>';
      btnConfig.id = `buttonConfig_jqxButton`;
      btnContainer.appendChild(btnConfig);

      const newIconConfig = document.getElementById('buttonConfig_jqxButton');
      if (newIconConfig) {
        btnConfig.title = this.translate('Configuracion');
      }

      btnConfig.addEventListener('click', async () => {
        this.cerradura = this.cerraduras().find((cerradura) => cerradura.id === rowdata.id);
        this.formLockConfiguracion = this.editConfiguracionComponent.createComponent(ConfiguracionCerradurasEditComponent);
        this.formLockConfiguracion.instance.init(this.formLockConfiguracion, this.cerradura.configuracion, this.cerradura.elemento, true, this.cerradura.nsMovisat, this.cerradura.nsFabricante);
        MenuComponent.getInstance().obsListComponent.next(this.formLockConfiguracion);
        this.listCerraduras.collapseWindow();
      });
    }

    if (rowdata && rowdata.elementoId && rowdata.metros !== 0 && rowdata.metros !== null) {
      const btnMover = document.createElement('div');
      btnMover.innerHTML = `
        <button id="config" style="height: 23px; width: 25px;  padding: 0; margin: 0; cursor: pointer !important;">
          <img style="float: left; height: 18px; width: 18px;" src="../assets/images/reubicar.png"/>
        </button>
      `;
      btnMover.id = `buttonMover_jqxButton`;
      btnContainer.appendChild(btnMover);

      const newIconMover = document.getElementById('buttonMover_jqxButton');
      if (newIconMover) {
        btnMover.title = this.translate('Reubicar');
      }

      btnMover.addEventListener('click', async () => {
        const modal: NzModalRef = this.modal.create({
          nzTitle: '<i>' + AppComponent.translate('ATENCION') + '</i>',
          nzContent: AppComponent.translate('Que_quiere_reubicar'),
          nzFooter: [
            {
              label: AppComponent.translate('Elemento'),
              type: 'primary',
              ghost: true,
              onClick(): void {
                const cerradura = ListadoCerraduraComponent.instance.cerraduras().find(cerr => cerr.id === rowdata.id);
                ListadoCerraduraComponent.instance.elementService.moveElement(cerradura.idElemento, cerradura.id, 'element').then(
                  () => {
                    ListadoCerraduraComponent.instance.cerraduraService.moveElementToCerradura(cerradura.id, false).then(
                      () => {
                        MainComponent.getInstance().showInfo(
                          'ATENCION',
                          'Registro_almacenado',
                          2000
                        );
                        modal.destroy();
                      }
                    )
                  }
                );
              }
            },
            {
              label: AppComponent.translate('Elemento_y_punto_ubicacion'),
              type: 'primary',
              ghost: true,
              onClick(): void {
                const cerradura = ListadoCerraduraComponent.instance.cerraduras().find(cerr => cerr.id === rowdata.id);
                ListadoCerraduraComponent.instance.elementService.moveElement(cerradura.idElemento, cerradura.id, 'ambos').then(
                  () => {
                    ListadoCerraduraComponent.instance.cerraduraService.moveElementToCerradura(cerradura.id, true).then(
                      () => {
                        MainComponent.getInstance().showInfo(
                          'ATENCION',
                          'Registro_almacenado',
                          2000
                        );
                        modal.destroy();
                      }
                    )
                  }
                );
              }
            },
            {
              label: AppComponent.translate('CANCELAR'),
              type: 'primary',
              danger: true,
              onClick: () => modal.destroy()
            },
          ],
          nzWidth: 650,
          nzCentered: true,
          nzZIndex: 999,
        });
      });
    }
  }

  protected onRowdoubleclick(args: {rowindex: string}): void {
    clearTimeout(this.clickTimer);  // Limpiamos el temporizador si se detecta un doble clic
    this.viewForm = true;
    const row = this.gridCerraduras.getrowdatabyid(args.rowindex);
    this.cerradura = this.cerraduras().find(cerradura => cerradura.id === row.id);
    this.cerradura.imsi = this.concatImsi(this.cerradura.mcc, this.cerradura.mnc, this.cerradura.icc);
    this.listCerraduras.collapseWindow();
  }

  protected onCellClick(args: {datafield: string, rowindex: string}): void {
    clearTimeout(this.clickTimer);  // Siempre limpiamos el temporizador con cada clic para reiniciar el proceso
    // Configuramos el temporizador
    this.clickTimer = setTimeout(() => {
      if (args.datafield !== 'Botones') {
        const row = this.gridCerraduras.getrowdatabyid(args.rowindex);
        this.onCentrar(row);
        this.viewForm = false;
        this.listCerraduras.expandWindow();
      }
    }, 500);  // 500 milisegundos de espera para determinar si es un clic individual
  }

  private concatImsi(mcc: string, mnc: string, icc: string): string {
    // concateno el icc, mcc, msi
    let imsi: string = '';
    // modifico para que salga con guiones y no null
    if (mcc === null) {
      imsi += '-';
      this.cerradura.mcc = '-';
    } else {
      imsi += String(mcc);
    }

    if (mnc === null) {
      imsi += '-';
      this.cerradura.mnc = '-';
    } else {
      imsi += String(mnc);
    }

    if (icc === null) {
      imsi += '-';
      this.cerradura.icc = '-';
    } else {
      imsi += String(icc);
    }
    return imsi;
  }

  // obtiene las cerraduras
  private getCerraduras = async (): Promise<void> => {
    this.elementos = MainComponent.getInstance().elementsList;
    try {
      this.loading.set(true);
      await this.cerraduraService.getCerraduras().then(
        (result) => {
          result.map(async cerradura => {
            const c = await this.cerraduraTransformer.transformCerraduraApiToList(cerradura);
            this.cerraduras().push(c);
            this.gridCerraduras.updatebounddata('data');
          })
          this.__updateWindowTitle(this.cerraduras().length);

          this.dataSource = {
            dataType: 'json',
            dataFields: [
              { name: 'Botones', type: 'string' },
              { name: 'id', type: 'number', map: 'id' },
              { name: 'elementoId', type: 'number', map: 'idElemento' },
              { name: 'tipoProducto', type: 'string', map: 'tipoOperacionStr' },
              { name: 'marca', type: 'string', map: 'elemento>marca' },
              { name: 'modelo', type: 'string', map: 'elemento>modelo' },
              { name: 'matricula', type: 'string', map: 'elemento>tag>matricula' },
              { name: 'elemento', type: 'string', map: 'elemento>nombre' },
              { name: 'configuracion', type: 'string', map: 'configuracion' },
              { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
              { name: 'nsFabricante', type: 'string', map: 'nsFabricante' },
              { name: 'version', type: 'string', map: 'versoft' },
              { name: 'imei', type: 'number', map: 'imei' },
              { name: 'mcc', type: 'number', map: 'mcc' },
              { name: 'mnc', type: 'number', map: 'mnc' },
              { name: 'icc', type: 'number', map: 'icc' },
              { name: 'elemento', type: 'string', map: 'elemento>nombre' },
              { name: 'provinciaIdentificacion', type: 'string', map: 'provinciaIdentificacion'},
              { name: 'municipioIdentificacion', type: 'string', map: 'municipioIdentificacion'},
              { name: 'poblacionIdentificacion', type: 'string', map: 'poblacionIdentificacion'},
              { name: 'calleIdentificacion', type: 'string', map: 'calleIdentificacion'},
              { name: 'numeroIdentificacion', type: 'number', map: 'numeroIdentificacion'},
              { name: 'metros', type: 'number', map: 'metros' },
              { name: 'provincia', type: 'string', map: 'elemento>provincia' },
              { name: 'municipio', type: 'string', map: 'elemento>municipio' },
              { name: 'poblacion', type: 'string', map: 'elemento>poblacion' },
              { name: 'calle', type: 'string', map: 'elemento>calle' },
              { name: 'numeroCalle', type: 'int', map: 'elemento>numeroCalle' },
              { name: 'marca', type: 'string', map: 'elemento>marca' },
              { name: 'modelo', type: 'string', map: 'elemento>modelo' },
              { name: 'matricula', type: 'string', map: 'elemento>tag>matricula' },
              { name: 'fechaModificacion', type: 'date', map: 'fechaUltimaConexion' },
              { name: 'horaModificacion', type: 'date', map: 'fechaUltimaConexion' },
              { name: 'observaciones', type: 'string', map: 'elemento>observaciones' },
              { name: 'pedirPosicion', type: 'number', map: 'pedirPosicion' },
              { name: 'fechaPeticionPosicion', type: 'date', map: 'fechaPeticionPosicion' },
              { name: 'horaPeticionPosicion', type: 'date', map: 'fechaPeticionPosicion' },
              { name: 'fechaRecepcionPosicion', type: 'date', map: 'fechaRecepcionPosicion' },
              { name: 'horaRecepcionPosicion', type: 'date', map: 'fechaRecepcionPosicion' },
              { name: 'selec', map: 'selec' }
            ],
            localdata: this.cerraduras()
          };
          this.dataAdapter = new jqx.dataAdapter(this.dataSource);
          this.onBuscar();
        }
      )
    }catch(e) {
      console.log(e);
      this.cerraduras.set([]);
    } finally {
      this.loading.set(false);
    }
  }

  protected updatefilterconditions = (type: string, defaultconditions): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  protected filter(cellValue: any, _rowData: any, dataField: string, filterGroup: any, defaultFilterResult: boolean): any {
    const filterColumns = [
      'tipoProducto',
      'marca',
      'modelo',
      'matricula',
      'elemento',
      'direccionIdentificador',
      'provincia',
      'municipio',
      'poblacion',
      'calle',
      'numeroCalle',
      'configuracion',
      'nsMovisat',
      'nsFabricante',
      'version',
      'elemento',
      'marca',
      'modelo',
      'matricula',
      'observaciones'
    ];

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }

  private createMarkers(position: MapLatLng, icono: string): MapMarker {
    const marker = this.map.addMarker({
      dataModel: '',
      title: '',
      content: '',
      position: position,
      icon: icono,
      zIndex: 999,
      drag: false,
      visible: true
    });
    this.markers.push(marker);
    return marker;
  }

  private onCentrar(data: CerraduraModel): void {
    const zonaArray = [];
    if (this.verDesdeColumn) {
      this.cerradura = this.cerraduras().find((cerradura) => cerradura.id === data.id);
      zonaArray[0] = this.cerradura;
    } else {
      zonaArray.forEach(element => {
        zonaArray.push({
          elemento: {
            lat: element.lat,
            lng: element.lng
          }
        });
      });

      if (!zonaArray.length) {
        return MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
      }
    }
    if (zonaArray.some(value => value.elemento == null) || zonaArray.some(value => value.lat == null) || zonaArray.some(value => value.lng == null)) {
      return MainComponent.getInstance().showError('ATENCION', 'No_existen_coordenadas', 2000);
    } else {

      let origenUbicacion = '';

      // primero compruebo si hay coordenadas en el elemento
      if (zonaArray.some(value => value.elemento.lat !== null || value.elemento.lng !== null)) {
        origenUbicacion = 'Elemento';
      } else if (zonaArray.some(value => value.lat !== null || value.lng !== null)) {
        origenUbicacion = 'Cerradura';
      }

      if (zonaArray.some(value => value.elemento.lat !== null && value.elemento.lng !== null) && zonaArray.some(value => value.lat !== null && value.lng !== null)) {
        origenUbicacion = 'Elemento';
      }

      this.encuadrarCerrradurasSelec(zonaArray);
      this.moverMarcadores(zonaArray, origenUbicacion);
    }
  }

  private moverMarcadores(cerraduras: CerraduraModel[], origenUbicacion: string): void {
    // encuentro el elemento  que esta en zonaArray
    const idElementos = cerraduras.map(value => value.elemento.id);
    const elementos = this.elementos.filter(value => idElementos.includes(value.Id));
    const markers = elementos.map(element => element.Marker);
    if (markers.length) {
      markers.forEach(marker => {
        marker.content = '<div style=margin: 10px;>' + marker.content + 'Origen Ubicación: ' + origenUbicacion + '</div>';
        marker.animate(3000);
      });
    }
  }

  private encuadrarCerrradurasSelec(value): void {
    this.markers.forEach(mark => {
      this.map.removeMarker(mark);
    });

    this.markers = [];

    const globalSWPoint = new MapLatLng(180, 90);
    const globalNEPoint = new MapLatLng(-180, -90);
    // Procesa cada zona
    value.forEach(cerradura => {
      let swPoint, nePoint;
      if (!MainComponent.getInstance().controlAmbitoActividad(new MapLatLng(cerradura.elemento.lat, cerradura.elemento.lng))) {
        this.toastrService.warning(
          AppComponent.translate('Fuera_ambito') + '<br>' +
          AppComponent.translate('Cerradura') + ':<br>' +
          cerradura.nsMovisat,
          AppComponent.translate('ATENCION'),
          {
            timeOut: 2000,
            positionClass: 'toast-top-center',
            enableHtml: true
          }
        );
      } else {
        swPoint = new MapLatLng(cerradura.elemento.lat, cerradura.elemento.lng);
        nePoint = new MapLatLng(cerradura.elemento.lat, cerradura.elemento.lng);

        swPoint = GeoUtils.getNewLatLng(cerradura.elemento, -50, -50);
        nePoint = GeoUtils.getNewLatLng(cerradura.elemento, 50, 50);

        globalSWPoint.lat = Math.min(globalSWPoint.lat, swPoint.lat);
        globalSWPoint.lng = Math.min(globalSWPoint.lng, swPoint.lng);
        globalNEPoint.lat = Math.max(globalNEPoint.lat, nePoint.lat);
        globalNEPoint.lng = Math.max(globalNEPoint.lng, nePoint.lng);

        const markerCerradura = this.createMarkers(new MapLatLng(cerradura.elemento.lat, cerradura.elemento.lng), 'assets/images/cerradura-gris.png');
        markerCerradura.content = '<div style="margin: 10px;">' + this.translate('Cerradura') + '<br>' + cerradura.nsMovisat + '</div>';
      }
    });
    this.map.fitTo(new MapBounds(globalSWPoint, globalNEPoint));
    this.markers.forEach(marker => {
      marker.animate(2800);
    })
  }

  // Si se seleccionan todos los elementos del grid
  protected onSelect(): void {
    const idRow: number[] = this.gridCerraduras.getselectedrowindexes();
    const rows = this.gridCerraduras.getrows();
    this.checkSelect = [];
    rows.forEach((element) => {
      if (idRow.includes(element.boundindex)) {
        const zona = this.cerraduras().find((elem) => elem.id == element.id);
        this.checkSelect.push(zona);
      }
    });
  }

  protected onUnSelect(id: number): void {
    this.checkSelect = this.checkSelect.filter(element => element.id !== id);
  }

  private onSubscribeMap(): void {
    if (!this.subscriptionOnMarkerDragEnd) {
      this.subscriptionOnMarkerDragEnd = this.map.subscribeOnMarkerDragEnd(
        this,
        (_this: any, marker: MapMarker) => {
          if (
            MainComponent.getInstance().controlAmbitoActividad(
              marker.position
            )
          ) {
            this.elemento.lat = marker.position.lat;
            this.elemento.lng = marker.position.lng;
          } else {
            if (this.elemento.lat && this.elemento.lng) {
              MainComponent.getInstance().showError(
                'ATENCION',
                'Fuera_ambito',
                2000
              );
              marker.setPosition(
                new MapLatLng(this.elemento.lat, this.elemento.lng)
              );
            }
          }
        }
      );
    }
  }

  private onPosicionar(): void {
    if (this.subscriptionOnMarkerDragEnd && this.checkSelect.length && this.checkSelect.some(value => value.elemento !== null)) {
      this.checkSelect = this.checkSelect.filter(element => element.elemento !== null);
      // limpio los marcadores
      if (this.markers.length > 0) {
        this.markers.forEach(marker => {
          this.map.removeMarker(marker);
        });
      }
      this.encuadrarCerrradurasSelec(this.checkSelect);
      this.listCerraduras.collapseWindow();
    } else if (!this.checkSelect.length) {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'No_existen_coordenadas', 2000);
    }
  }

  // botones de acciones
  public async onLocalizar(): Promise<void> {
    const pedirPosicion: PosicionCerraduraModel = new PosicionCerraduraModel(this.checkSelect.map(value => value.id), this.empresaId);
    if (pedirPosicion && pedirPosicion.idsCerraduras.length !== 0) {
      const result: any = await this.cerraduraService.pedirPosicion(pedirPosicion);
      if (result.state == 'ok') {
        MainComponent.getInstance().showSuccess('ATENCION', 'Peticion_localizacion_realizada', 2000);
        this.gridCerraduras.clearselection();
        this.checkSelect = [];
      }
    } else {
      MainComponent.getInstance().showError('ATENCION', 'Error_enviar_localizacion', 2000);
    }
  }

  protected eventFilter(): void {
    this.header.searchInput['nativeElement'].value = '';
    this.getCerraduras();
  }

  protected eventResetFilter(): void {
    this.header.searchInput['nativeElement'].value = '';
    this.onBuscar();
    this.header.metrosInput.value(0);
  }

  protected onBuscar(): void {
    const filterValue = this.header.searchInput['nativeElement'].value.length >= 3
      ? this.header.searchInput['nativeElement'].value.toUpperCase()
      : '';

    this.cerraduras().forEach(cerr => {
      const matchesSearch = [
        cerr?.idElemento,
        cerr?.tipoOperacionStr,
        cerr?.nsMovisat,
        cerr?.nsFabricante,
        cerr?.versoft,
        cerr?.imei,
        cerr?.sim,
        this.concatImsi(cerr.mcc, cerr.mnc, cerr.icc),
        cerr?.elemento?.nombre,
        cerr?.elemento?.marca,
        cerr?.elemento?.modelo,
        cerr?.elemento?.tag?.matricula,
        cerr?.fechaUltimaConexionStr,
        cerr?.elemento?.observaciones,
      ].filter(
        prop => !!prop
      ).some(
        (prop: string | number) => this.__isContainedInOrInvalid(prop, filterValue)
      );

      // FIXME: Use chain of responsability or some aggregative filter
      const matchesMetros = this.__isLessThanOrInvalid(cerr?.metros, this.metrosFilter) ? 'selec' : '';

      cerr['selec'] = (matchesSearch && matchesMetros) ? 'selec' : '';
    });

    this.__ensureGridFiltersAreRegistered();
    this.__tirggerGridFilters();
  }

  protected onExportar(): void {
    if (this.gridCerraduras.getrows().length === 0) {
      return MainComponent.getInstance().showWarning('ATENCION', this.translate('No_existen_datos'), 2000);
    } else {
      const json = this.gridCerraduras.exportdata('json');
      const datos = JSON.parse(json);
      // Utiliza el array modificado en lugar del JSON original
      const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(datos);
      this.generateAutofilterHeader(ws);
      const wb: xlsx.WorkBook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
      xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate('Cerradura_iot') + '.xlsx');
    }
  }

  private generateAutofilterHeader(sheet: xlsx.WorkSheet): void {
    // Añade filtro a todas las casillas.
    sheet['!autofilter'] = { ref: sheet['!ref'] };
  }

  protected onClose(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }

    if (this.subscriptionOnMarkerDragEnd) {
      this.subscriptionOnMarkerDragEnd.unsubscribe();
      this.subscriptionOnMarkerDragEnd = null;
    }

    if (this.informacionCerradura) {
      this.informacionCerradura.destroy();
      this.viewForm = false;
    }

    ListadoCerraduraComponent.instance = null;

    if (this.markers.length > 0) {
      this.markers.forEach(marker => {
        this.map.removeMarker(marker);
      });
      this.markers = [];
    }
  }

  public onGridDataUpdated(): void {
    this.__updateWindowTitle(this.gridCerraduras.getrows().length);
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  private __updateWindowTitle(countCerradures: number): void {
    this.windowTitle.set(this.translate('Cerradura_iot') + ` (${countCerradures})`)
  }

  private __ensureGridFiltersAreRegistered(): void {
    const filters = this.gridCerraduras.getfilterinformation();

    // Check selec filter
    if (!filters.some(filter => filter.datafield === 'selec')) {
      const filtergroup = new jqx.filter();

      filtergroup.operator = 'and';
      filtergroup.addfilter(0, filtergroup.createfilter('stringfilter', 'selec', 'equal'));

      this.gridCerraduras.addfilter('selec', filtergroup);
    }
  }

  private __tirggerGridFilters(): void {
    this.gridCerraduras.applyfilters();
    this.gridCerraduras.updatebounddata('data');
  }

  // FIXME: use a generic function or service, check lodash if has this logic (utilitary needed)
  private __isLessThanOrInvalid = (a?: number, b?: number): boolean => !Number.isInteger(b) || b <= 0 || !!a && a < b;
  private __isContainedInOrInvalid = (a?: string | number, b?: string): boolean => !b || !a || String(a).toUpperCase().includes(b);
}
